module.exports = __webpack_public_path__ + "assets/f4ad1a788502d42d1d5b177bfffd20d9.png";